import Heading from "@/components/Heading";
import { FileUploader } from "devextreme-react";
import { toast } from "react-toastify";

type Props = {
  logo: File | null;
  setLogo: (logo: File | null) => void;
};

const LogoInput = ({ logo, setLogo }: Props) => {
  const handleFileChange = (files: File[]) => {
    if (files.length > 0) {
      const file = files[0];
      if (file?.type.startsWith("image/")) {
        setLogo(file);
      } else {
        toast.error("Invalid file type. Please upload an image file.");
      }
    }
  };

  return (
    <div>
      <Heading text="Upload Logo" />
      <FileUploader
        accept="image/*"
        value={logo ? [logo] : []}
        onValueChange={handleFileChange}
        uploadMode="useForm"
      />
      <p className="text-xs text-neutral-100">
        Please upload an image file only. <br /> Image size should be no bigger than 250px in width
        and 50px in height.
      </p>
    </div>
  );
};

export default LogoInput;
